import { useReducer } from 'react';
import axios from 'axios';

// Selectors

import useAppSelector from './useAppSelector';

// constants

import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import { IEX_STATE_CODES } from '@constants/configs/states';

const actions = {
    GET_PROFILE: 'GET_PROFILE'
};

const api = axios.create({
    headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': window.csrf_token,
        'X-UID': window.UID,
        'X-EMAIL': window.EMAIL,
        'csrftoken': window.csrf_token
    }
});

const GET_DESIGNATION_PROFILE_URL = '/hix/designation/profile';
const GET_DESIGNATION_PROFILE_URL_FOR_DEV_ENVIRONMENT = '/mocks/designation-profile.json';

const DEDESIGNATE_ASSISTER_URL = '/hix/entity/assister/dedesignateAssister';

const DEDESIGNATE_BROKER_URL = '/hix/broker/dedesignate';

export interface BrokerProfileResponse {
    id: number;
    encryptedId: string;
    role: string;
    firstName: string;
    lastName: string;
    contactNumber: string;
    designateStatus: 'Active' | 'Pending' | null;
    isConsentPageEnabled: 'Y' | 'N';
    responseCode: number;
}

function reducer(state, { type, payload }) {
    switch (type) {
        case actions.GET_PROFILE:
            return {
                ...state,
                brokerProfile: payload
            };
        default:
            return state;
    }
}

export default () => {
    const [data, dispatch] = useReducer(reducer, {
        brokerProfile: undefined
    });

    const dedesignateAssister = async id => {
        return await api.get(`${DEDESIGNATE_ASSISTER_URL}/${id}`);
    };

    const dedesignateBroker = async encryptedId => {
        return await api.post(`${DEDESIGNATE_BROKER_URL}/${encryptedId}`);
    };

    const getBrokerProfile = async (stateCode: string, userRole: string) => {
        try {
            const res = await api.get<BrokerProfileResponse>(
                global.__ENV__.PRODUCTION
                    ? GET_DESIGNATION_PROFILE_URL
                    : GET_DESIGNATION_PROFILE_URL_FOR_DEV_ENVIRONMENT
            );

            //
            const {
                designateStatus,
                id,
                isConsentPageEnabled
            } = res?.data || {};
            const allowedRoles = [
                ALL_USER_ROLES.INDIVIDUAL,
                ALL_USER_ROLES.ASSISTER,
                ALL_USER_ROLES.BROKER,
                ALL_USER_ROLES.L2_CSR,
                ALL_USER_ROLES.ADMIN,
                ALL_USER_ROLES.AGENCY_MANAGER,
                ALL_USER_ROLES.L1_CSR,
                ALL_USER_ROLES.SUPERVISOR,
                ALL_USER_ROLES.ENTITY_MANAGER,
                ALL_USER_ROLES.ASSISTERENROLLMENTENTITY,
                ALL_USER_ROLES.ASSISTERENROLLMENTENTITYADMIN
            ];
            const isAllowedUsers = allowedRoles.includes(userRole);
            const isShowGears = stateCode !== IEX_STATE_CODES.CA && (isConsentPageEnabled.length < 1 || isConsentPageEnabled === 'N') && id !== null && id > 0 && isAllowedUsers;
            const isShowDedesignateMsg = userRole !== ALL_USER_ROLES.EMPLOYEE && (designateStatus === 'Pending' || designateStatus === 'Active');

            dispatch({ type: actions.GET_PROFILE, payload: {...res.data, isShowDedesignateMsg, isShowGears }});
        } catch (e) {
            console.log(`Request to ${GET_DESIGNATION_PROFILE_URL} failed`);
        }
    };

    const getHouseIconVisibility = () => {
        const { isState } = useAppSelector(state => state.common.environment);
        return isState.PA || isState.IL || isState.NM || isState.NV;
    };

    return {
        ...data,
        dedesignateAssister: id => {
            return dedesignateAssister(id);
        },
        dedesignateBroker: encryptedId => {
            return dedesignateBroker(encryptedId);
        },
        getBrokerProfile: (stateCode: string, userRole: string) => {
            getBrokerProfile(stateCode, userRole);
        },
        isHouseIconVisible: getHouseIconVisibility()
    };
};